const $ = window.jQuery

const IMAGE_FILE_SUFFIX_LIST = ['jpeg', 'jpg', 'png']

export const isImageFile = (fileName) => {
  const suffix = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
  return IMAGE_FILE_SUFFIX_LIST.indexOf(suffix) > -1
}

export const uploadFile = (url, file, {progressCallback, cancelCallback, successCallback, errorCallback}) => {
	const xhr = {};
	xhr[url] = $.ajax({
		type: 'PUT',
		url: url,
		data: file,
		xhrFields: {
			withCredentials: false
		},
		processData: false,
		contentType: false,
		headers: {
			'Content-Type': file.type
		},
		crossDomain: true,
		success: function (result) {
			successCallback()
		},
		error: function (xhr, type) {
			errorCallback()
		},
		xhr: function () {
			var xhr = $.ajaxSettings.xhr();
			if (progressCallback && xhr.upload){
				xhr.upload.onprogress = function (e) {
					progressCallback(e.loaded / e.total * 100, onCancel);
				}
			}
			return xhr;
		}
	});
	const onCancel = function () {
		xhr[url].abort();
		cancelCallback && cancelCallback();
	}

	return {xhr, onCancel}
}

export const hwTemUrlUpload = async (file, token, onProgerss, onChange) => {
  let isCanCel = false;
  let key = token.keyTokenParis[0].key;
  const { type, size } = file;
	uploadFile(token.keyTokenParis[0].token, file, {
    progressCallback: (percent, onCancel) => {
			if (isCanCel) {
				onCancel();
				return;
			}
      onProgerss && onProgerss(percent, onCancel);
    }, 
    cancelCallback: () => {
			isCanCel = true;
      onChange && onChange({});
    }, 
    successCallback: async () => {
      let url = `${token.host}/${key}`;
      if(!isCanCel){
        onChange && onChange({
          src: url,
          fileName:file.name,
        });
      }
    }, 
    errorCallback: () => {
      onChange && onChange({});
    }
  })
}